import React, { useMemo, useState } from 'react'

import R from 'ramda'
import numeral from 'numeral'
import {
  Bar,
  BarChart,
  CartesianGrid,
  LabelList,
  Legend,
  XAxis,
  YAxis,
} from 'recharts'

const CauseCodeEventTypeBarGraph = props => {
  const { actualHeight = 470, actualWidth = 500, data } = props
  const [totalCommaOps, setTotalCommaOps] = useState(0)
  const barData = useMemo(
    _ => {
      const nd = convertBarData(data)

      const total = R.compose(
        R.sum,
        R.filter(f => f > 0),
        R.map(([_, v]) => v),
        R.toPairs
      )(nd)
      setTotalCommaOps(total)

      const cd = R.compose(
        R.map(([k, v]) => ({
          name: k,
          origValue: v > 0 ? parseInt(v) + 1 : v,
          value: (Math.abs(v) / total) * 100,
          text: `${k} (${v >= 0 ? '+' : '-'}) $${numeral(v).format(
            '000,000'
          )} (${(parseFloat(Math.abs(v) / total) * 100).toFixed(2)}%)`,
        })),
        R.toPairs
      )(nd)
      return cd
    },
    [data]
  )

  return (
    <div
      style={{
        height: actualHeight + 'px',
        width: actualWidth + 'px',
        // border: '1px solid black',
      }}
    >
      <div
        style={{
          width: '100%',
          display: 'grid',
          gridTemplateColumns: '70% 30%',
        }}
      >
        <span style={{ fontSize: '20px', width: '100%', textAlign: 'end' }}>
          CommOps True Up by Event Type
        </span>
        <span
          style={{
            fontSize: '15px',
            width: '100%',
            textAlign: 'end',
            alignContent: 'center',
          }}
        >
          (Total CommOps True Up : $
          {numeral(totalCommaOps).format('000,000,000')})
        </span>
      </div>
      <BarChart
        width={actualWidth}
        height={actualHeight}
        data={barData}
        margin={{
          top: 5,
          right: 30,
          left: 40,
          bottom: 5,
        }}
        layout="vertical"
        // barCategoryGap="30%"
      >
        <CartesianGrid strokeDasharray="1 3" />
        <XAxis dataKey="value" type="number" tickFormatter={e => e + '%'} />
        <YAxis dataKey="name" type="category" />
        {/* <Tooltip /> */}
        <Legend />
        <Bar
          dataKey="value"
          fill="#8884d8"
          type="category"
          // activeBar={<Rectangle fill="pink" stroke="blue" />}
          name="Percentage"
        >
          <LabelList
            dataKey="text"
            position="insideLeft"
            // content={e => {
            //   return 'fff'
            // }}
            // textBreakAll={false}
            width={500}
          />
        </Bar>
      </BarChart>
    </div>
  )
}

const convertBarData = data => {
  let totalCommOpsTrueUp = 0.0
  let totalLOF = 0.0
  let totalRS = 0.0
  let finalData = {
    'Forced Outage': 0,
    'Forced Derate': 0,
    Maintenance: 0,
    Planned: 0,
    RS: 0,
    'No Event': 0,
    Adjustments: 0,
  }
  for (let i = 0; i < data.length; i++) {
    const trueUp = parseFloat(data[i].trueUp)
    const evtType = data[i].eventtype + ''
    const causeCode = data[i].causecode ? data[i].causecode + '' : ''
    if (!isNaN(trueUp)) {
      if (causeCode.includes('9130') || causeCode.includes('9131')) {
        totalLOF = totalLOF + trueUp
        // totalCommOpsTrueUp = totalCommOpsTrueUp + trueUp.doubleValue();
        continue
      }

      if (
        evtType.includes('U1') ||
        evtType.includes('U2') ||
        evtType.includes('U3') ||
        evtType.includes('SF')
      ) {
        totalCommOpsTrueUp = totalCommOpsTrueUp + trueUp
        // if (dataset.getKeys().indexOf("Forced Outage") >= 0) {
        //     Number tempVal = dataset.getValue("Forced Outage").doubleValue() + trueUp.doubleValue();
        //     dataset.setValue("Forced Outage", tempVal);
        // } else
        //     dataset.setValue("Forced Outage", trueUp);

        finalData = {
          ...finalData,
          'Forced Outage': parseFloat(finalData['Forced Outage']) + trueUp,
        }
      } else if (
        evtType.includes('D1') ||
        evtType.includes('D2') ||
        evtType.includes('D3') ||
        evtType.includes('DE')
      ) {
        totalCommOpsTrueUp = totalCommOpsTrueUp + trueUp
        // if (dataset.getKeys().indexOf("Forced Derate") >= 0) {
        //     Number tempVal = dataset.getValue("Forced Derate").doubleValue() + trueUp.doubleValue();
        //     dataset.setValue("Forced Derate", tempVal);
        // } else
        //     dataset.setValue("Forced Derate", trueUp);

        finalData = {
          ...finalData,
          'Forced Derate': parseFloat(finalData['Forced Derate']) + trueUp,
        }
      } else if (
        evtType.includes('MO') ||
        evtType.includes('D4') ||
        evtType.includes('ME') ||
        evtType.includes('DM')
      ) {
        totalCommOpsTrueUp = totalCommOpsTrueUp + trueUp
        // if (dataset.getKeys().indexOf("Maintenance") >= 0) {
        //     Number tempVal = dataset.getValue("Maintenance").doubleValue() + trueUp.doubleValue();
        //     dataset.setValue("Maintenance", tempVal);
        // } else
        //     dataset.setValue("Maintenance", trueUp);
        finalData = {
          ...finalData,
          Maintenance: parseFloat(finalData.Maintenance) + trueUp,
        }
      } else if (
        evtType.includes('PO') ||
        evtType.includes('PE') ||
        evtType.includes('SE') ||
        evtType.includes('PD') ||
        evtType.includes('DP') ||
        evtType.includes('NC')
      ) {
        totalCommOpsTrueUp = totalCommOpsTrueUp + trueUp
        // if (dataset.getKeys().indexOf("Planned") >= 0) {
        //     Number tempVal = dataset.getValue("Planned").doubleValue() + trueUp.doubleValue();
        //     dataset.setValue("Planned", tempVal);
        // } else
        //     dataset.setValue("Planned", trueUp);
        finalData = {
          ...finalData,
          Planned: parseFloat(finalData.Planned) + trueUp,
        }
      } else if (evtType.includes('RS')) {
        // || evtType.equals("MB") || evtType.equals("RU") || evtType.equals("IR")
        totalRS = totalRS + trueUp
        totalCommOpsTrueUp = totalCommOpsTrueUp + trueUp
        // if (dataset.getKeys().indexOf("RS") >= 0) {
        //     Number tempVal = dataset.getValue("RS").doubleValue() + trueUp.doubleValue();
        //     dataset.setValue("RS", tempVal);
        // } else
        //     dataset.setValue("RS", trueUp);
        finalData = { ...finalData, RS: parseFloat(finalData.RS) + trueUp }
      } else if (evtType.includes('IS')) {
        totalCommOpsTrueUp = totalCommOpsTrueUp + trueUp
        // if (dataset.getKeys().indexOf("No Event") >= 0) {
        //     Number tempVal = dataset.getValue("No Event").doubleValue() + trueUp.doubleValue();
        //     dataset.setValue("No Event", tempVal);
        // } else
        //     dataset.setValue("No Event", trueUp);
        finalData = {
          ...finalData,
          'No Event': parseFloat(finalData['No Event']) + trueUp,
        }
      } else if (evtType.includes('TA')) {
        totalCommOpsTrueUp = totalCommOpsTrueUp + trueUp
        // if (dataset.getKeys().indexOf("Adjustments") >= 0) {
        //     Number tempVal = dataset.getValue("Adjustments").doubleValue() + trueUp.doubleValue();
        //     dataset.setValue("Adjustments", tempVal);
        // } else
        //     dataset.setValue("Adjustments", trueUp);
        finalData = {
          ...finalData,
          Adjustments: parseFloat(finalData.Adjustments) + trueUp,
        }
      }
    }
  }
  //   const keys=Object.keys(finalData)
  //   for (let i = 0; i < keys.length; i++) {
  //     const keyVal =  finalData[keys[i]];
  //     if (keyVal < 0)
  //         dataset.setValue(keyVal + " (-)", Math.abs(dataset.getValue(keyVal).doubleValue()));
  //       //finalData={...finalData,keys[i]:}
  //     else
  //         dataset.setValue(keyVal + " (+)", dataset.getValue(keyVal));

  //     dataset.remove(keyVal);
  // }
  return finalData
}

/* public PieDataset createEvtTypeData(DefaultMetaInfoTableModel evtTypeModel) {
  DefaultPieDataset dataset = new DefaultPieDataset();
  totalCommOpsTrueUp = 0.0;
  totalLOF = 0.0;
  totalRS = 0.0;
  for (int i = 0; i < evtTypeModel.getRowCount(); i++) {
      Number trueUp = (Number) evtTypeModel.getRawData("TRUE_UP", i);
      String evtType = evtTypeModel.getRawData("EVENTTYPE", i) + "";
      String causeCode = evtTypeModel.getRawData("CAUSECODE", i) + "";
      if (trueUp != null) {

          if (causeCode.contains("9130") || causeCode.contains("9131")) {
              totalLOF = totalLOF + trueUp.doubleValue();
              //totalCommOpsTrueUp = totalCommOpsTrueUp + trueUp.doubleValue();
              continue;
          }

          if (evtType.equals("U1") || evtType.equals("U2") || evtType.equals("U3") || evtType.equals("SF")) {
              totalCommOpsTrueUp = totalCommOpsTrueUp + trueUp.doubleValue();
              if (dataset.getKeys().indexOf("Forced Outage") >= 0) {
                  Number tempVal = dataset.getValue("Forced Outage").doubleValue() + trueUp.doubleValue();
                  dataset.setValue("Forced Outage", tempVal);
              } else
                  dataset.setValue("Forced Outage", trueUp);
          } else if (evtType.equals("D1") || evtType.equals("D2") || evtType.equals("D3") || evtType.equals("DE")) {
              totalCommOpsTrueUp = totalCommOpsTrueUp + trueUp.doubleValue();
              if (dataset.getKeys().indexOf("Forced Derate") >= 0) {
                  Number tempVal = dataset.getValue("Forced Derate").doubleValue() + trueUp.doubleValue();
                  dataset.setValue("Forced Derate", tempVal);
              } else
                  dataset.setValue("Forced Derate", trueUp);
          } else if (evtType.equals("MO") || evtType.equals("D4") || evtType.equals("ME") || evtType.equals("DM")) {
              totalCommOpsTrueUp = totalCommOpsTrueUp + trueUp.doubleValue();
              if (dataset.getKeys().indexOf("Maintenance") >= 0) {
                  Number tempVal = dataset.getValue("Maintenance").doubleValue() + trueUp.doubleValue();
                  dataset.setValue("Maintenance", tempVal);
              } else
                  dataset.setValue("Maintenance", trueUp);
          } else if (evtType.equals("PO") || evtType.equals("PE") || evtType.equals("SE") || evtType.equals("PD") || evtType.equals("DP") || evtType.equals("NC")) {
              totalCommOpsTrueUp = totalCommOpsTrueUp + trueUp.doubleValue();
              if (dataset.getKeys().indexOf("Planned") >= 0) {
                  Number tempVal = dataset.getValue("Planned").doubleValue() + trueUp.doubleValue();
                  dataset.setValue("Planned", tempVal);
              } else
                  dataset.setValue("Planned", trueUp);
          } else if (evtType.equals("RS")) { // || evtType.equals("MB") || evtType.equals("RU") || evtType.equals("IR")
              totalRS = totalRS + trueUp.doubleValue();
              totalCommOpsTrueUp = totalCommOpsTrueUp + trueUp.doubleValue();
              if (dataset.getKeys().indexOf("RS") >= 0) {
                  Number tempVal = dataset.getValue("RS").doubleValue() + trueUp.doubleValue();
                  dataset.setValue("RS", tempVal);
              } else
                  dataset.setValue("RS", trueUp);
          } else if (evtType.equals("IS")) {
              totalCommOpsTrueUp = totalCommOpsTrueUp + trueUp.doubleValue();
              if (dataset.getKeys().indexOf("No Event") >= 0) {
                  Number tempVal = dataset.getValue("No Event").doubleValue() + trueUp.doubleValue();
                  dataset.setValue("No Event", tempVal);
              } else
                  dataset.setValue("No Event", trueUp);
          } else if (evtType.equals("TA")) {
              totalCommOpsTrueUp = totalCommOpsTrueUp + trueUp.doubleValue();
              if (dataset.getKeys().indexOf("Adjustments") >= 0) {
                  Number tempVal = dataset.getValue("Adjustments").doubleValue() + trueUp.doubleValue();
                  dataset.setValue("Adjustments", tempVal);
              } else
                  dataset.setValue("Adjustments", trueUp);
          }
      }
  }

  java.util.List keysList = dataset.getKeys();
  for (int i = 0; i < keysList.size(); i++) {
      Comparable keyVal = (Comparable) keysList.get(i);
      if (dataset.getValue(keyVal).doubleValue() < 0)
          dataset.setValue(keyVal + " (-)", Math.abs(dataset.getValue(keyVal).doubleValue()));
      else
          dataset.setValue(keyVal + " (+)", dataset.getValue(keyVal));

      dataset.remove(keyVal);
  }

  return dataset;
}
*/

export default CauseCodeEventTypeBarGraph
